import IconFacebook from 'assets/icons/icon-facebook.svg'
import LogoAmway from 'assets/images/logo-amway.png'
import LogoTeammak from 'assets/images/logo-teammak.png'
import { useAuthentication } from 'modules/authentication'
import { Link } from 'react-router-dom'

const year = new Date().getFullYear()

export const Footer: ReactFC = () => {
    const { isLoggedIn } = useAuthentication()

    return (
        <footer className="footer">
            <div className="wrapper">
                <div className="footer__main s-top--lrg">
                    <div className="social s-bottom--med">
                        <a href="https://www.facebook.com/myteammak/">
                            <img src={IconFacebook} alt="facebook icon" />
                        </a>
                    </div>
                    <Link to="/contact">
                        <h2 className="t-small t-secondary">Contact us</h2>
                    </Link>
                </div>

                <div className="footer__main">
                    <Link
                        className="t-center s-top--lrg"
                        to="/terms-and-conditions"
                    >
                        <h2 className="t-small t-secondary">
                            Terms &amp; Conditions
                        </h2>
                    </Link>
                    <a
                        className="t-center s-top--lrg"
                        href="/terms-and-conditions#ticketing"
                    >
                        <h2 className="t-small t-secondary">
                            Registration/Ticketing Terms &amp; Conditions
                        </h2>
                    </a>
                    <Link className="t-center s-top--lrg" to="/privacy-policy">
                        <h2 className="t-small t-secondary">Privacy Policy</h2>
                    </Link>
                </div>

                {isLoggedIn && (
                    <div className="footer__logo-container s-top--lrg">
                        <a
                            href="https://amway.com.au"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={LogoAmway}
                                className="footer__logo"
                                alt="Amway Logo"
                                title="Amway"
                            />
                        </a>
                        <Link to="/">
                            <img
                                src={LogoTeammak}
                                className="footer__logo"
                                alt="TeamMak Logo"
                                title="TeamMak"
                            />
                        </Link>
                    </div>
                )}

                <p className="t-center t-small u-opacity--60">
                    &copy; {year}. Copyrights by TeamMak. All rights reserved.
                </p>
            </div>
        </footer>
    )
}
